







import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'ui-button',
})
export default class UiButtonComponent extends Vue {
  @Prop({ default: '0.40em 0.75em' }) padding!: string;
  @Prop({ default: '' }) color!: string;
  @Prop({ default: false }) active!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) border: boolean;
  @Prop({ type: Number, default: 100 }) width: number;
  @Prop({ default: '', type: String }) icon: string;

  emitClick() {
    // console.log("ui-button")
    if (!this.disabled) this.$emit('onClick');
  }
  get innerStyle(): Object {
    return {
      backgroundColor: this.color,
      // padding: this.padding,
      minWidth: this.width + 'px',
    };
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-button/src/ui-button.vue